import { FC, Fragment } from 'react';
import moment from 'moment';

import { yearList } from '../helpers';
import { ETabDataPicker } from '../index';
import ISelectDatepicker from '../SelectDatepicker';

const YearSelect: FC<ISelectDatepicker.IPropsSelectedItem> = ({
  handleChange,
  dateSelected,
  minDate,
  tabSelected,
}) => (
  <Fragment>
    {yearList(minDate).map((yearItem) => (
      <div
        key={yearItem}
        className={`
          tw-text-[12px] tw-text-center tw-flex tw-items-center tw-justify-center tw-text-gray200 
          tw-border
          hover:tw-text-green500 tw-cursor-pointer ${
            tabSelected[ETabDataPicker.YEAR] && moment(dateSelected).year() === yearItem
              ? 'tw-border-green500 tw-text-green500 tw-rounded-md'
              : 'tw-border-transparent'
          }
          
        `}
        onClick={() => {
          handleChange(ETabDataPicker.YEAR, yearItem);
        }}
      >
        {yearItem}
      </div>
    ))}
  </Fragment>
);

export default YearSelect;
